module.exports = __webpack_public_path__ + "static/media/sell_send_money_5.332df9b1.jpg";